<!--
 * @Author: gaoxueting
 * @Date: 2020-06-19 17:55:21
 * @LastEditTime: 2020-08-03 18:12:32
 * @LastEditors: fengzhongmei
 * @Description:
-->
<template>
    <Modal v-model="modal"
           :mask-closable="false"
           :title="$t('申请虚拟IP')"
           @on-cancel="cancel"
           width=560
           class="add-network">
        <Form :label-width="120"
              :model="formData"
              :rules="rules">
            <FormItem :label="$t('当前子网')+'：'">
                <p>{{baseInfo.networkName}}</p>
                <p style="color:#808080">当前子网网段: {{baseInfo.cidr.split('/')[0]}}</p>
            </FormItem>

            <FormItem :label="$t('创建方式')+'：'">
                <RadioGroup v-model="formData.createType"
                            type="button">
                    <Radio label="autoAssign">{{$t('自动分配')}}</Radio>
                    <Radio label="assignByHand">{{$t('手动分配')}}</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem :label="$t('IP地址')+'：'"
                      v-if="formData.createType === 'assignByHand'"
                      prop="cidr">
                <InputNumber :max="255"
                             :min="0"
                             :disabled='true'
                             style="width: 70px"
                             v-model="formData.cidr0"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             :disabled='true'
                             style="width: 70px"
                             v-model="formData.cidr1"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             :disabled='disabledFlag'
                             style="width: 70px"
                             v-model="formData.cidr2"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 70px"
                             v-model="formData.cidr3"></InputNumber>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button @click="cancel()"
                    class="ivu-btn-text">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="save()">{{$t('保存')}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api.js'
// import { getOne } from '@/service/utils.js'
export default {
    name: 'createvirip',
    props: ['envId', 'baseInfo'],
    components: {
    },
    data () {
        return {
            modal: false,
            loading: false,
            cidr: null,
            disabledFlag: true,
            formData: {
                createType: 'autoAssign',
                cidr0: null,
                cidr1: null,
                cidr2: null,
                cidr3: null
            },
            rules: {}
        }
    },
    created () {
    },
    methods: {
        // 打开弹出框
        openModal () {
            this.cidr = this.baseInfo.cidr.split('/')[0]
            const cidrArr = this.cidr.split('.')
            this.formData.cidr0 = Number(cidrArr[0])
            this.formData.cidr1 = Number(cidrArr[1])
            this.formData.cidr2 = Number(cidrArr[2])
            this.formData.cidr3 = Number(cidrArr[3])
            if (Number(cidrArr[2]) === 0) {
                this.disabledFlag = false
            }
            this.modal = true
        },
        // 取消
        cancel () {
            this.modal = false
            this.formData = {
                createType: 'autoAssign',
                cidr0: null,
                cidr1: null,
                cidr2: null,
                cidr3: null
            }
        },
        // 表单提交
        save () {
            const cidr = this.formData.cidr0 + '.' + this.formData.cidr1 + '.' + this.formData.cidr2 + '.' + this.formData.cidr3
            const params = {
                cloudEnvId: this.envId,
                vpcId: this.baseInfo.netVpcId,
                subnetId: this.baseInfo.id,
                fixedIp: this.formData.createType === 'assignByHand' ? cidr : ''
            }
            this.loading = true
            this.axios.post(this.urlFormat(API.GET_PORTS, false), params).then(res => {
                if (res.status) {
                    this.cancel()
                    this.$emit('refresh')
                }
                this.loading = false
            }).catch(e => {
                this.loading = false
            })
        }
    }
}
</script>

<style lang="less">
</style>
